import React, { useCallback, useState } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { DifferenceSection } from './components/DifferenceSection';
import { OutcomeOffer } from './components/OutcomeOffer';
import { ServicesSection } from './components/ServicesSection';
import { PromiseCta } from './components/PromiseCta';
import { ReviewsSection } from './components/ReviewsSection';
import { FaqSection } from './components/FaqSection';
import { WorkGallery } from './components/WorkGallery';
import { SiteFooter } from './components/SiteFooter';
import { LegalModal } from './components/LegalModal';
import { EstimateProvider } from './contexts/EstimateContext';
import { FloatingEstimateButton } from './components/FloatingEstimateButton';
import { LegalDocId } from './data/legal';
export function App() {
  const [legalDoc, setLegalDoc] = useState<LegalDocId | null>(null);
  const closeLegal = useCallback(() => setLegalDoc(null), []);
  return <EstimateProvider data-id="element-0" data-mp="3ii4sg33z0up3">
      <div className="min-h-screen w-full bg-cream" data-id="element-1" data-mp="3mlaxj7fckftz">
        <SiteHeader data-id="element-2" data-mp="3mjq27fl7ksv2" />
        <main data-id="element-3" data-mp="3mj6k9yvk64h1">
          <Hero data-id="element-4" data-mp="3rcj6y3gog175" />
          <ProblemSection data-id="element-5" data-mp="3rbzmog3k10py" />
          <DifferenceSection data-id="element-6" data-mp="3rcsxpt9jqcdw" />
          <OutcomeOffer data-id="element-7" data-mp="3relumgucxi8p" />
          <ServicesSection data-id="element-8" data-mp="5opww5kum4f" />
          <WorkGallery data-id="element-9" data-mp="4wylxj0jajy" />
          <ReviewsSection data-id="element-10" data-mp="56m9egl55mh" />
          <FaqSection data-id="element-11" data-mp="2zl3bdjx5744s" />
          <PromiseCta data-id="element-12" data-mp="2zllijblcf2rh" />
        </main>
        <SiteFooter onOpenLegal={setLegalDoc} data-id="element-13" data-mp="2zmo7vf30ox5a" />
        <LegalModal openDoc={legalDoc} onChange={setLegalDoc} onClose={closeLegal} data-id="element-14" data-mp="33mf0zpg0npcz" />
        <FloatingEstimateButton data-id="element-15" data-mp="38lro8basuyg3" />
      </div>
    </EstimateProvider>;
}